import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { getLessonStatusKey } from 'utils/lesson';

import './side-panel__lesson-status.scss';

interface StoreProps {
    lessonStatus: LESSON_STATUS | null;
}

interface Props extends StoreProps {}

export const LessonStatus = ({ lessonStatus }: Props) => {
    if (!lessonStatus) {
        return null;
    }

    return (
        <span
            className={b('side-panel', 'lesson-status', {
                'in-progress': lessonStatus === LESSON_STATUS.IN_PROGRESS,
                'not-solved': lessonStatus === LESSON_STATUS.NOT_SOLVED,
                'finish-forced': lessonStatus === LESSON_STATUS.FINISH_FORCED,
            })}
        >
            <Text id={getLessonStatusKey(lessonStatus)} />
        </span>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        lessonStatus: lessonSelectors.getLessonStatus(storeState) || LESSON_STATUS.NOT_ASSIGNED,
    };
};

export default connect(mapStateToProps)(LessonStatus);
